import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

export function registerDataConnectorMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('dataConnectors', locale)
}
